'use client';
import React, { useEffect } from 'react';
import { useTranslations } from 'next-intl';
import { dayFormat, getLangInClient } from '@/lib/helpers/functions';
import { Job } from '@/lib/types/customer/restaurant/StoreProfile';
import Button from '@/components/ui/Button';
import { Arrow2 } from '@/components/ui/Icons';
import { STOREFRONT } from '@/lib/utils/translation';
import {
  BriefcaseIcon,
  CalendarDaysIcon,
  CreditCardIcon,
  MapPinIcon,
} from '@heroicons/react/24/outline';
import { City } from '@/lib/types/customer/RestaurantJobs';

type Props = {
  job: Job;
  restaurantName: string;
  city: City;
};

export default function JobDetailsCard({ job, restaurantName, city }: Props) {
  const [jobCity, setJobCity] = React.useState<string | null | undefined>(null);
  const lang = getLangInClient();
  const t = useTranslations();

  useEffect(() => {
    if (job) {
      setJobCity(city.name);
    }
  }, [job, lang]);
  return (
    <div className="flex flex-col">
      <span className="mb-[10px] text-sm text-title">{restaurantName}</span>
      <span className="mb-[25px] text-h4 font-bold text-title">
        {job.title}
      </span>
      <div className="mb-[40px] flex flex-wrap gap-[10px]">
        {job.salary != null &&
          ((typeof job.salary === 'string' && parseFloat(job.salary) > 0) ||
            (typeof job.salary === 'number' && job.salary > 0)) && (
            <span className="flex w-fit rounded-[5px] border border-neutral-100 bg-[#F1F1F4] px-[10px] py-[5px] text-sm text-paragraph">
              <CreditCardIcon className="mr-[8px] h-[18px] w-[18px]" />
              {job.formatted_currency?.salary}
              {job.salary_type != null && job.salary_type.length > 0
                ? `/${job.salary_type_formatted}`
                : ''}
            </span>
          )}
        <span className="flex w-fit rounded-[5px] border border-neutral-100 bg-[#F1F1F4] px-[10px] py-[5px] text-sm capitalize text-paragraph">
          <BriefcaseIcon className="mr-[8px] h-[18px] w-[18px]" />
          {job.type_formatted?.join(', ')}
        </span>
        <span className="flex w-fit rounded-[5px] border border-neutral-100 bg-[#F1F1F4] px-[10px] py-[5px] text-sm capitalize text-paragraph">
          <MapPinIcon className="mr-[8px] h-[18px] w-[18px]" />
          {jobCity ?? 'Germany'}
        </span>
        {job.deadline != null && (
          <span className="flex w-fit rounded-[5px] border border-neutral-100 bg-[#F1F1F4] px-[10px] py-[5px] text-sm capitalize text-paragraph md:ml-auto">
            <CalendarDaysIcon className="mr-[8px] h-[18px] w-[18px]" />
            {/* {dayjs(job.deadline).format(date_format)} */}
            {dayFormat(job.deadline).locale('de').format('ll')}
          </span>
        )}
      </div>
      <div
        className="prose mb-[20px] text-paragraph"
        dangerouslySetInnerHTML={{
          __html: job.description,
        }}
      />

      <Button className="w-fit">
        <a
          href={`mailto:${job.email}?subject=${job.title}`}
          className="flex items-center text-sm"
        >
          {t(STOREFRONT.STORE_PROFILE + '.apply_now')}{' '}
          <Arrow2 className="ml-[5px]" />
        </a>
      </Button>
    </div>
  );
}
